import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiCallService2 } from '../../routes/dashboard/pages/Real-time-perfomance/api-call-service'; // Replace with your actual service path

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent {
  message: string = '';
  moisture: number | null = null;

  constructor(
    public dialogRef: MatDialogRef<AlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiCallService2: ApiCallService2
  ) {
    const burnerPosition = data && data.popupData ? data.popupData.recommended_burner_position : undefined;
    this.moisture = data && data.alert_msg && data.alert_msg.moisture_per !== undefined ? data.alert_msg.moisture_per : null;

    if (burnerPosition !== undefined && burnerPosition !== null) {
      this.message = burnerPosition;
      this.speakMessage(`The recommended burner position is ${this.message} percent.`);
    } else {
      this.message = 'No popup message available';
    }
  }

  speakMessage(text: string): void {
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = 'en-US';
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(utterance);
  }

  onAccept(): void {
    console.log(this.data)
    const payload = {
      id: this.data.id,
      choice: true,
      response:'accepted'
    };

    this.apiCallService2.postChoice(payload).subscribe(
      (res) => {
        console.log('User accepted, response sent:', res);
        this.speakMessage('You have accepted the recommended burner position');
        this.dialogRef.close('accepted');
      },
      (err) => {
        console.error('Error sending accept response:', err);
        this.dialogRef.close('accepted'); // Optionally still close on error
      }
    );
  }

  onReject(): void {
    console.log('User rejected, no API call sent');
    const payload = {
      id: this.data.id,
      choice: false,
      response:'rejected'
    };
    this.apiCallService2.postChoice(payload).subscribe(
      (res) => {
        console.log('User rejected, response sent:', res);
        this.speakMessage('You have rejected the recommended burner position');
        this.dialogRef.close('rejected');
      },
      (err) => {
        console.error('Error sending reject response:', err);
        this.dialogRef.close('rejected'); // Optionally still close on error
      }
    );
    this.dialogRef.close('rejected');
  }
  onIgnore():void{
    const payload = {
      id: this.data.id,
      choice: null,
      response:'ignored'
    };
    this.apiCallService2.postChoice(payload).subscribe(
      (res) => {
        console.log('User ignored, response sent:', res);
        this.speakMessage('You have ignored the recommended burner position');
        this.dialogRef.close('ignored');
      },
      (err) => {
        console.error('Error sending reject response:', err);
        this.dialogRef.close('ignored'); // Optionally still close on error
      }
    );
    this.dialogRef.close('ignored');
  }
}
